/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowFigureASquareUpIcon16Solid = forwardRef('ArrowFigureASquareUpIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 11.5A3.5 3.5 0 0 0 4.5 15h7a3.5 3.5 0 0 0 3.5-3.5v-7A3.5 3.5 0 0 0 11.5 1h-7A3.5 3.5 0 0 0 1 4.5v7Zm3.55-3.445a.75.75 0 0 0 1.058-.061L7.25 6.15v5.616a.75.75 0 0 0 1.5 0V6.15l1.642 1.844a.75.75 0 0 0 1.12-.998L9.307 4.52a1.75 1.75 0 0 0-2.614 0L4.488 6.996a.75.75 0 0 0 .061 1.059Z" })));
});
